// ======================================================================
// File Name       : ContentHistoryConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const CONTENT_TYPE_STR = [
  { value: null, name: null },
  { value: 0, name: 'ビデオ' },
  { value: 1, name: 'ドリル' },
  { value: 3, name: 'ドキュメント' },
  { value: 5, name: 'リンク' },
];

export const DATA_AFFILIATION_TYPE = [
  { value: null, name: null },
  { value: 0, name: '内部コンテンツ' },
  { value: 1, name: '外部コンテンツ' },
];

export const CONTENT_TYPE = {
  MOVIE: 0,
  DRILL_TEST: 1,
  QUESTION: 2,
  DOCUMENT: 3,
  LINK: 5,
};

export const DRILL_RESULT_EXP = {
  CORRECT_ANSWER_NUM: 0,
  CORRECT_ANSWER_RATE: 1,
  SCORE: 2,
  INTERRUPTION: 3,
  IN_PROCESS: 4,
};

export const END_CONDITION_TYPE_FOR_ITEM = {
  NO_CONDITION: 0,
  ACHIEVEMENT_RATE: 1,
};

export const START_CONDITION = [
  { value: 0, name: 'はじめから開始' },
  { value: 1, name: 'つづきから開始' },
  { value: 2, name: 'ミス問（前回のミス）スタート' },
  { value: 3, name: 'ミス問（過去のミス）スタート' },
  { value: 4, name: 'お気に入り問題スタート' },
];

export const DRILL_KIND = [
  { value: 0, name: 'ノーマルモード' },
  { value: 1, name: '再解答モード' },
  { value: 2, name: 'テストモード' },
  { value: 4, name: 'アダプティブモード' },
  { value: 5, name: '添削モード' },
  { value: 6, name: 'アンケートモード' }, // #7269
];

// #7386 START
export const DRILL_KIND_FOR_DISPLAY_BAR_CHART = [0, 1, 2, 5];
export const COMPLETION_CONDITION_STR = 'completionCondition';
export const MAX_COLUMN_BAR_CHART = 10;
export const MAX_CHARACTERS_DISPLAY_ON_AGGREGATE_BY_PROBLEM = 50;
// #7386 END

export const MAX_QUESTION_DISPLAY_GOBACK_LINK = 5;